export type ControlRoomFlag =
  | "previewPanel"
  | "sessionSwitcher"
  | "readOnlySubagentPanel"
  | "multiRunFusion"
  | "miniChat"
  | "settingsPolish"

export type ControlRoomSettings = Record<ControlRoomFlag, boolean>
export type ControlRoomChannel = "dev" | "beta" | "prod"
export type ControlRoomPlatform = "web" | "desktop"

export function controlRoomDefaults(input: {
  channel?: string
  platform: ControlRoomPlatform
}): ControlRoomSettings {
  const channel = input.channel === "prod" || input.channel === "beta" || input.channel === "dev" ? input.channel : "dev"
  const experimental = input.platform === "desktop" && channel !== "prod"
  return {
    previewPanel: input.platform === "desktop",
    sessionSwitcher: input.platform === "desktop",
    readOnlySubagentPanel: input.platform === "desktop",
    multiRunFusion: experimental,
    miniChat: experimental,
    settingsPolish: true,
  }
}

export function isControlRoomEnabled(
  settings: ControlRoomSettings,
  flag: ControlRoomFlag,
  platform: ControlRoomPlatform,
) {
  if (platform !== "desktop" && flag !== "settingsPolish") return false
  return settings[flag]
}
